import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { LANGUAGE_CODES, USER_INFO } from "@constants/global.constants";

import WPDropdown from "@components/WPDropdown";

import localLang from "../WPLanguageDropDown/language.json";

import "./WPLanguageDropDown.scss";

const WPLanguageDropDown = ({ className, setTermsLanguage }) => {
  const { t, i18n } = useTranslation();

  const language = useSelector(state => state.userInfo?.data?.language || USER_INFO);
  const languages = useSelector(state => {
    const langs = state.globalAppData?.languages;
    return langs && langs.length > 0 ? langs : localLang;
  });

  const [selectedLanguage, setSelectedLanguage] = useState(i18n?.language ?? language);

  const handleLanguageChange = async selectedOption => {
    setSelectedLanguage(selectedOption);
    setTermsLanguage(selectedOption.cultureName);
  };

  const getLanguageLabel = option => (
    <div>
      <img src={LANGUAGE_CODES[option.languageId]?.flag} alt={option.translatedName} className='languageIcon' />
      {option.translatedName}
    </div>
  );

  return (
    <div className={className}>
      <WPDropdown
        id='dropdown_languages'
        value={selectedLanguage || languages[0]}
        options={languages}
        placeholder={t("myProfile.selectLanguage")}
        onChange={handleLanguageChange}
        getOptionLabel={getLanguageLabel}
        className='wp-language-dropdown'
      />
    </div>
  );
};

export default WPLanguageDropDown;
